module.exports = __webpack_public_path__ + "img/ctrl-a-stub-down-0.c85982ce.svg";